import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { ProjectModel } from '@smarttask-common/src/lib/models/Project/Core/ProjectModel';

export enum ProjectActionTypes {
    ADD_PROJECT = '[Project] Create Project',
    ADD_PROJECTS = '[Project] Add Projects',
    UPSERT_PROJECT = '[Project] Upsert Project',
    UPSERT_PROJECTS = '[Project] Upsert Projects',
    UPDATE_PROJECT = '[Project] Update Project',
    UPDATE_PROJECTS = '[Project] Update Projects',
    DELETE_PROJECT = '[Project] Delete Project',
    DELETE_PROJECTS = '[Project] Delete Projects',
    DELETE_ALL_PROJECTS = '[Project] Delete All Projects',
    DELETE_ALL = '[Project] Delete All',

    UPDATE_SELECTED_ID = '[Project] Update SelectedId',
}

export class UpdateSelectedProjectId implements Action {
    readonly type = ProjectActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_project_id: string) {}
}

export class AddOne implements Action {
    readonly type = ProjectActionTypes.ADD_PROJECT;
    constructor(public project: ProjectModel) {}
}

export class AddMany implements Action {
    readonly type = ProjectActionTypes.ADD_PROJECTS;
    constructor(public projects: Array<ProjectModel>) {}
}

export class UpsertOne implements Action {
    readonly type = ProjectActionTypes.UPSERT_PROJECT;

    constructor(public project: ProjectModel) {}
}

export class UpsertMany implements Action {
    readonly type = ProjectActionTypes.UPSERT_PROJECTS;
    constructor(public projects: Array<ProjectModel>) {}
}

export class UpdateOne implements Action {
    readonly type = ProjectActionTypes.UPDATE_PROJECT;
    constructor(public project: Update<ProjectModel>) {}
}

export class UpdateMany implements Action {
    readonly type = ProjectActionTypes.UPDATE_PROJECTS;
    constructor(public projects: Array<Update<ProjectModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = ProjectActionTypes.DELETE_PROJECT;
    constructor(public id: string) {}
}

export class DeleteMany implements Action {
    readonly type = ProjectActionTypes.DELETE_PROJECTS;
    constructor(public ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = ProjectActionTypes.DELETE_ALL_PROJECTS;
    constructor(public ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = ProjectActionTypes.DELETE_ALL;
    constructor() {}
}

export type ProjectActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedProjectId;
